@for (participant of vm.participants; track participant.horse.id) {
    <div class="antepost-option-market">
        <span class="fixture-label fixture-pick-title">{{ participant.horse.name | msTranslate }}</span>
        @if (participant.eventOption) {
            <ms-hr-option-pick
                class="odds-info ms-selectable-pick"
                [option]="participant.eventOption"
                [optionGroup]="selectedOptionGroup"
                [event]="vm.fixture"
                [pickType]="pickType"
                [trackingSource]="trackingSource"
                [trackingOptions]="getTrackingOptions(fixture)">
                @if (participant.eventOption.online) {
                    <div>
                        @switch (participant.eventOption.participantPriceType) {
                            @case (priceType.Fixed) {
                                <span class="option-value">
                                    {{ participant.eventOption.nativePrice | msNativePriceFormatter }}
                                </span>
                            }
                            @case (priceType.StartingPrice) {
                                <span>{{ sitecore.betslip.messages.StartingPrice }}</span>
                            }
                        }
                    </div>
                }
                @if (!participant.eventOption.online) {
                    <div class="lock odds-info">
                        <vn-icon name="theme-locked-i" size="12" class="option-lock-icon" />
                    </div>
                }
            </ms-hr-option-pick>
        }
    </div>
}
